import React  from 'react';
import {Row, Col, Button} from 'react-bootstrap';
import { useParams } from 'react-router-dom';

const Onboarding = () => {

  let { accountKey, 
    //startFactDate, endFactDate 
  } = useParams();

  return (
    <>
      <h2>Welcome to Reconify</h2>
      <div className='mb-3'>
        Reconify provides actionable insights for Generative AI
      </div>
      <Row className='mb-3' sm={1} lg={3} md={2}>
        <Col className='mb-4'>
        <div className='onboard-card card-icon-detail'>
          <div className='card-icon-detail-img'>
            <img src='/feature-usage.png' alt=''/>
          </div>
          <div className='card-icon-detail-text'>
            <div className='onboard-title'>Usage Metrics</div>
            <div>
              <ul>
                <li>Users and Sessions</li>
                <li>Model token usage</li>
                <li>Latency</li>
              </ul>
            </div>
          </div>
        </div>
        </Col>
        <Col className='mb-4'>
        <div className='onboard-card card-icon-detail'>
          <div className='card-icon-detail-img'>
            <img src='/feature-gears.png' alt=''/>
          </div>
          <div className='card-icon-detail-text'>
          <div className='onboard-title'>Prompt Analysis</div>
          <div>
            <ul>
              <li>Top prompts</li>
              <li>Prompt clusters</li>
              <li>Prompt flows</li>
            </ul>
            </div>
          </div>
        </div>
        </Col>
        <Col className='mb-4'>
        <div className='onboard-card card-icon-detail'>
          <div className='card-icon-detail-img'>
            <img src='/feature-responses.png' alt=''/>
          </div>
          <div className='card-icon-detail-text'>
          <div className='onboard-title'>Response Insights</div>
          <div>
            <ul>
              <li>Top responses</li>
              <li>Response clusters</li>
              <li>Response flows</li>
            </ul>
            </div>
          </div>
        </div>
        </Col>
     {/*  </Row>
      <Row className='mb-5'>*/}
        <Col className='mb-4'>
        <div className='onboard-card card-icon-detail'>
          <div className='card-icon-detail-img'>
            <img src='/feature-transcripts.png' alt=''/>
          </div>
          <div className='card-icon-detail-text'>
          <div className='onboard-title'>Transcripts</div>
          <div>
            <ul>
              <li>Interactions</li>
              <li>Transcripts</li>
            </ul>
            </div>
          </div>
        </div>
        </Col>
        <Col className='mb-4'>
        <div className='onboard-card card-icon-detail'>
          <div className='card-icon-detail-img'>
            <img src='/feature-costs.png' alt=''/>
          </div>
          <div className='card-icon-detail-text'>
          <div className='onboard-title'>Costs</div>
          <div>
            <ul>
              <li>Model costs</li>
              <li>Cost by App</li>
            </ul>
            </div>
          </div>
        </div>
        </Col>
        <Col className='mb-4'>
        <div className='onboard-card card-icon-detail'>
          <div className='card-icon-detail-img'>
            <img src='/feature-integration.png' alt=''/>
          </div>
          <div className='card-icon-detail-text'>
          <div className='onboard-title'>Easy Integration</div>
          <div>
            <ul>
              <li>NPM & Python modules</li>
              <li>REST API</li>
            </ul>
            </div>
          </div>
        </div>
        </Col>
      </Row>
      <h2>Get Started</h2>
      <div className='mb-4'>
        <p>To get started, add an app to your account and follow the integration steps on the details page.</p>
        <p>Data will begin to appear immediately in the Interactions and Transcripts reports. 
          The other reports update hourly.</p>
        <p>For more info, see the <a href="https://www.reconify.com/docs" target="_blank" rel="noreferrer">documentation</a>.</p>
        <Button href={`/account/${accountKey}/apps/add`}>Add an App</Button>
      </div>
    </>

  )

}

export default Onboarding;
